import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { Folder, Grid } from '@octopus-do/octopus-storybook/icons'
import type {
  WorkspaceBase,
  WorkspaceItem,
} from '@store/reducers/dashboard/types'
import type React from 'react'

import { TeamAvatar } from './TeamAvatar'
import { WorkspaceFolders } from './WorkspaceFolders'

interface Props {
  workspaces: WorkspaceBase[]
  folders: WorkspaceItem[]
  showDashboard: boolean
}

export const WorkspacesContent: React.FC<Props> = ({
  workspaces,
  folders,
  showDashboard,
}) => {
  const showDivider = showDashboard || folders.length > 0

  return (
    <>
      {showDashboard && (
        <DropdownMenu.Button icon={Grid} id="" title="Dashboard" />
      )}
      {folders.map((f) => (
        <DropdownMenu.Button
          icon={Folder}
          id={f.id}
          title={f.title}
          key={f.id}
        />
      ))}
      {showDivider && <DropdownMenu.Divider />}
      {workspaces.map(({ id, title, avatar, folders }) => (
        <DropdownMenu.NestedMenu
          key={id}
          content={WorkspaceFolders}
          id={id}
          title={title}
          folders={folders}
        >
          <TeamAvatar avatar={avatar} />
        </DropdownMenu.NestedMenu>
      ))}
    </>
  )
}
